import React from 'react';
import { CreditCard, Building2, Info } from 'lucide-react';

const SEPA_MAX = 10000;

/**
 * Payment method selector — CB or SEPA Direct Debit.
 * Auto-disables SEPA when total > 10 000 € (Stripe cap).
 */
export const PaymentMethodSelector = ({ method, onChange, total }) => {
  const sepaBlocked = total > SEPA_MAX;
  const onClickSepa = () => {
    if (sepaBlocked) return;
    onChange('sepa');
  };
  return (
    <div className="space-y-3" data-testid="payment-method-selector">
      <div className="text-sm font-semibold text-white/90 mb-2">Choisissez votre moyen de paiement</div>

      <button
        type="button"
        onClick={() => onChange('card')}
        className={`w-full text-left p-4 rounded-lg border-2 transition flex items-start gap-3 ${
          method === 'card'
            ? 'border-yellow-400/80 bg-yellow-400/5'
            : 'border-white/10 hover:border-white/30 bg-white/5'
        }`}
        data-testid="payment-method-card"
      >
        <div className={`mt-0.5 w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${
          method === 'card' ? 'border-yellow-400' : 'border-white/40'
        }`}>
          {method === 'card' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />}
        </div>
        <CreditCard className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <div className="font-semibold text-white">Carte bancaire</div>
          <div className="text-xs text-white/60 mt-0.5">
            Visa, Mastercard, American Express. Validation instantanée.
          </div>
        </div>
        <div className="text-[10px] uppercase tracking-wider text-yellow-400/80 font-semibold">Recommandé</div>
      </button>

      <button
        type="button"
        onClick={onClickSepa}
        disabled={sepaBlocked}
        className={`w-full text-left p-4 rounded-lg border-2 transition flex items-start gap-3 ${
          sepaBlocked
            ? 'border-white/5 bg-white/5 opacity-40 cursor-not-allowed'
            : method === 'sepa'
              ? 'border-yellow-400/80 bg-yellow-400/5'
              : 'border-white/10 hover:border-white/30 bg-white/5'
        }`}
        data-testid="payment-method-sepa"
      >
        <div className={`mt-0.5 w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${
          method === 'sepa' ? 'border-yellow-400' : 'border-white/40'
        }`}>
          {method === 'sepa' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />}
        </div>
        <Building2 className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <div className="font-semibold text-white">Prélèvement SEPA</div>
          <div className="text-xs text-white/60 mt-0.5">
            Saisie de l'IBAN, signature électronique du mandat. Validation par notre équipe sous 48h ouvrées.
          </div>
        </div>
      </button>

      {sepaBlocked && (
        <div className="flex items-start gap-2 text-xs text-yellow-300/90 bg-yellow-400/5 border border-yellow-400/20 rounded-md p-3" data-testid="sepa-blocked-notice">
          <Info className="w-4 h-4 flex-shrink-0 mt-0.5" />
          <span>
            Pour les commandes supérieures à <strong>10 000 €</strong>, seul le paiement par carte
            bancaire est disponible (plafond SEPA).
          </span>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodSelector;
